module.exports = __webpack_public_path__ + "img/Icons copy.cc8beace.png";